import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import supabase from '../supabase/supabase';
import { gallery, testimonials } from '../data';

export function Gallery() {
  return (
    <section className="section gallery-section">
      <div className="container">
        <div className="section-heading"><h2>Our Work</h2><p>A few examples of the work we can help with.</p></div>
        <div className="gallery-grid">
          {gallery.map(([title, image]) => (
            <figure key={title}><img src={image} alt={title} /><figcaption>{title}</figcaption></figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Testimonials() {
  const [active, setActive] = useState(0);
  const [approved, setApproved] = useState([]);

  useEffect(() => {
    supabase.from('crm_reviews_20261009').select('id,reviewer_name,rating,body')
      .eq('approved', true).order('created_at', { ascending: false })
      .then(({ data }) => { if (data) setApproved(data); });
  }, []);

  const entries = [
    ...approved.map((review) => [review.body, review.reviewer_name, `${review.rating}/5 stars`, review.id]),
    ...testimonials
  ];

  useEffect(() => {
    const timer = setInterval(() => setActive((value) => (value + 1) % entries.length), 5000);
    return () => clearInterval(timer);
  }, [entries.length]);

  return (
    <section className="section testimonials-section">
      <div className="container">
        <div className="section-heading"><h2>What Our Customers Say</h2></div>
        <div className="testimonial-grid" style={{ '--active': active }}>
          {entries.map(([quote, name, service, id], index) => (
            <article className={`testimonial-card ${active === index ? 'featured' : ''}`} key={id || `${name}-${index}`}>
              <div className="stars">{[0, 1, 2, 3, 4].map((star) => <SafeIcon icon={FiIcons.FiStar} key={star} />)}</div>
              <blockquote>“{quote}”</blockquote>
              <strong>{name}</strong><span>{service}</span>
            </article>
          ))}
        </div>
        <div className="carousel-dots">
          {entries.map((item, index) => (
            <button className={active === index ? 'active' : ''} onClick={() => setActive(index)} aria-label={`Show testimonial ${index + 1}`} key={item[3] || `${item[1]}-${index}`} />
          ))}
        </div>
      </div>
    </section>
  );
}